export class MinecraftBlockBreakerInstructions {
  /** Session key used to track user's audio preference */
  static audioSessionKey = 'unlocked.minecraft.blockbreakeraudiomuted'

  static get muted() {
    return sessionStorage.getItem(MinecraftBlockBreakerInstructions.audioSessionKey) === 'true'
  }

  static set muted(value) {
    sessionStorage.setItem(MinecraftBlockBreakerInstructions.audioSessionKey, value ? 'true' : 'false')
  }

  /**
   * Stores Audio objects for each of the block breaking sounds, grouped by block type
   * @type {Object}
   */
  static sfx = {}

  static sfxFiles = {
    amethyst: [
      'amethyst_break1.wav',
      'amethyst_break2.wav',
      'amethyst_break3.wav',
      'amethyst_break4.wav'
    ],
    cloth: [
      'cloth_break1.wav',
      'cloth_break2.wav',
      'cloth_break3.wav',
      'cloth_break4.wav'
    ],
    copper: [
      'copper_break1.wav',
      'copper_break2.wav',
      'copper_break3.wav',
      'copper_break4.wav'
    ],
    grass: [
      'grass_break1.wav',
      'grass_break2.wav',
      'grass_break3.wav',
      'grass_break4.wav',
      'grass_break5.wav',
      'grass_break6.wav'
    ],
    gravel: [
      'gravel_break1.wav',
      'gravel_break2.wav',
      'gravel_break3.wav',
      'gravel_break4.wav'
    ],
    sand: [
      'sand_break1.wav',
      'sand_break2.wav',
      'sand_break3.wav',
      'sand_break4.wav'
    ],
    snow: [
      'snow_break1.wav',
      'snow_break2.wav',
      'snow_break3.wav',
      'snow_break4.wav'
    ],
    stone: [
      'stone_break1.wav',
      'stone_break2.wav',
      'stone_break3.wav',
      'stone_break4.wav'
    ],
    wood: [
      'wood_break1.wav',
      'wood_break2.wav',
      'wood_break3.wav',
      'wood_break4.wav'
    ]
  }

  constructor (element) {
    this.element = element

    const muteButton = this.element.querySelector('.js-minecraft-block-breaker-mute-audio')
    this.muteButtonController = window.unlocked.toggleButtons[muteButton.dataset.buttonid]

    this.initializeMuteToggle()
  }

  /**
   * Initializes the mute toggle button(s)
   * @param {HTMLElement} element
   */
  initializeMuteToggle = () => {
    this.muteButtonController.onClick = (state, elem, obj) => {
      this.muteButtonController.setState(state === 'play' ? 'mute' : 'play')
    }

    // Do this BEFORE adding state change listeners
    this.muteButtonController.setState(MinecraftBlockBreakerInstructions.muted ? 'play' : 'mute')
    this.toggleMuteIcon(this.muteButtonController.state)

    this.muteButtonController.onStateChange = (state, elem) => {
      if (state === 'play') {
        elem.ariaPressed = false
        MinecraftBlockBreakerInstructions.muted = true
      } else if (state === 'mute') {
        elem.ariaPressed = true
        MinecraftBlockBreakerInstructions.muted = false

        const materials = Object.keys(MinecraftBlockBreakerInstructions.sfx)
        MinecraftBlockBreakerInstructions.playAudio(materials[Math.floor(Math.random() * materials.length)])
      }

      this.toggleMuteIcon(state)
    }
  }

  /**
   * Toggles the visible states of the mute button
   * @param {HTMLElement} muteButton
   * @param {String} state
   */
  toggleMuteIcon = (state) => {
    this.muteButtonController.element.querySelectorAll('[data-decorator-index] [data-state]').forEach(decorator => {
      if (decorator.dataset.state === state) {
        decorator.classList.remove('decorator--hidden')
      } else {
        decorator.classList.add('decorator--hidden')
      }
    })
  }

  /**
   * Plays a randomly selected audio effect for the given material
   * @type {String}
   */
  static playAudio = (audioKey) => {
    if (!MinecraftBlockBreakerInstructions.muted && audioKey !== 'none') {
      const audio = new Set(MinecraftBlockBreakerInstructions.sfx[audioKey])
      if (audio.size > 0) {
        const prev = new Set([MinecraftBlockBreakerInstructions[`_prev-${audioKey}`]])
        const candidates = Array.from(audio.difference(prev))

        const selected = candidates[Math.floor(Math.random() * candidates.length)]
        MinecraftBlockBreakerInstructions[`_prev-${audioKey}`] = selected

        selected?.play()
      }
    }
  }

  static loadAudio = (audioKey) => {
    if (
      audioKey !== 'none' &&
      audioKey in MinecraftBlockBreakerInstructions.sfxFiles &&
      !(audioKey in MinecraftBlockBreakerInstructions.sfx)
    ) {
      MinecraftBlockBreakerInstructions.sfx[audioKey] = MinecraftBlockBreakerInstructions.sfxFiles[audioKey].map(file => new Audio(`${unlocked.theme_dir}/blocks/minecraft_block_breaker_instructions/audio/${file}`))
      MinecraftBlockBreakerInstructions[`_prev-${audioKey}`] = undefined
    }
  }
}

export default {
  selector: '.js-minecraft-block-breaker-instructions',
  Source: MinecraftBlockBreakerInstructions
}
